import {
  alpha,
  Avatar,
  Box,
  Button,
  Grid,
  Typography,
  useTheme,
} from '@mui/material';
import React from 'react';

import tenantInactiveImage from '@/assets/images/png/tenant_inactive.png';
import Logo from '@/assets/images/svg/TSV_Logo.svg';

import { HeaderWrapper } from '../StyledComponents';

interface TenantInactiveProps {
  isNotFound?: boolean;
}

const TenantInactive: React.FC<TenantInactiveProps> = ({ isNotFound }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        overflow: 'hidden',
      }}
    >
      <HeaderWrapper>
        <Avatar
          src={Logo}
          variant='square'
          sx={{ width: 101, height: 32, cursor: 'pointer', mb: 1 }}
        />
        <Button variant='contained' disabled={true}>
          Login
        </Button>
      </HeaderWrapper>
      <Grid
        container
        direction='column'
        justifyContent='center'
        alignItems='center'
        style={{
          textAlign: 'center',
          padding: '2rem',
          flex: 1,
          backgroundColor: '#FFF',
        }}
      >
        <Grid>
          <img
            src={tenantInactiveImage}
            alt={isNotFound ? 'Tenant Not Found' : 'Tenant Inactive'}
            style={{ maxWidth: '100%', marginBottom: '2rem', height: 'auto' }}
          />
        </Grid>
        <Grid
          sx={{
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            py: '1rem',
            px: '2rem',
            marginTop: '1rem',
          }}
        >
          <Typography variant='h6' style={{ fontWeight: 600 }}>
            Thank you for checking with us.
          </Typography>
          <Typography
            variant='body1'
            style={{
              marginTop: '0.5rem',
              marginBottom: '0.5rem',
              opacity: 0.8,
            }}
          >
            It appears that the service you are trying to access is currently
            {isNotFound ? ' not found.' : ' inactive.'}
          </Typography>
          <Typography variant='body1' style={{ opacity: 0.8 }}>
            If this is unexpected, please contact your system administrator for
            further assistance.
          </Typography>
        </Grid>
      </Grid>
      <Box
        px={3.5}
        py={1.5}
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: 'white',
        }}
      >
        <Typography fontSize={12}>Powered by - Shares.Vision</Typography>
        <Typography fontSize={12}>©Trusted services</Typography>
      </Box>
    </Box>
  );
};

export default TenantInactive;
